const INITIAL_LIST = [
  'zh',
  'ch',
  'sh',
  'z',
  'c',
  's',
  'b',
  'p',
  'm',
  'f',
  'd',
  't',
  'n',
  'l',
  'g',
  'k',
  'h',
  'j',
  'q',
  'x',
  'r',
  'y',
  'w',
  '',
];
export default INITIAL_LIST;
